import { useState } from "react";

import PublicLayout from "@/containers/PublicLayout";
import { Episode } from "@/types/Episode";
import { User } from "@/types/User";
import { cx } from "@/utils";
import AllEarsTitle from "@components/AllEarsTitle";
import Wizard from "@components/Wizard";

import Activate from "./partials/Activate";
import LoadingNotice from "./partials/LoadingNotice";
import Onboarding from "./partials/Onboarding";
import OnboardingContext from "./partials/OnboardingContext";

import styles from "./ActivationView.module.css";

const STEPS = [Activate, LoadingNotice, Onboarding];

const ActivationView = () => {
  const [featuredMention, setFeaturedMention] = useState<Episode | null>(null);
  const [user, setUser] = useState<User | undefined>(undefined);
  const [missingFeatured, setMissingFeatured] = useState(false);
  const [animated, setAnimated] = useState(0);

  return (
    <PublicLayout
      className={cx(styles.root, {
        [styles.stepOne]: animated === 1,
        [styles.stepTwo]: animated === 2,
      })}
    >
      <AllEarsTitle title={L.ACTIVATE_TITLE} />
      <div>
        <OnboardingContext.Provider
          value={{
            user,
            setUser,
            missingFeatured,
            setMissingFeatured,
            featuredMention,
            setFeaturedMention,
          }}
        >
          <Wizard steps={STEPS} onStepChange={(num) => setAnimated(num)} />
        </OnboardingContext.Provider>
      </div>
    </PublicLayout>
  );
};
export default ActivationView;
